if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}


document.addEventListener("DOMContentLoaded", function() {
    var longText = document.getElementById('collection-hero__description');
    var readMoreBtn = document.getElementById('readMoreBtn');
  var announcementBar = document.querySelector('.announcement-bar-section');
    var isExpanded = false;

    readMoreBtn.addEventListener('click', function() {
        if (!isExpanded) {
            longText.style.height = 'auto';
            readMoreBtn.textContent = 'Read Less';
            isExpanded = true;
        } else {
            longText.style.height = '200px'; // Adjust this value to your desired height
            readMoreBtn.textContent = 'Read More';
            isExpanded = false;
announcementBar.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });
});
